

<div class="card" id="tarjeta">
  <div class="row">
    <a [routerLink]="['/home/left-sidebar/product', product.sku]" class="col-6 col-sm-12 img-card-mobile">
      <img class="card-img-top img-fluid" [src]="getUrl(product.photos)"
        onerror="this.src='https://s3-sa-east-1.amazonaws.com/buho-images/multiclient/upload/photos-articles/imageNotAvailable'"
        alt="Distrimay">
    </a>
    <div class="card-body col-6 col-sm-12">
      <a [routerLink]="['/home/left-sidebar/product', product.sku]">
        <h5 class="card-title" matTooltip="{{product.name}}" [matTooltipPosition]="'above'">
          {{product.name | slice:0:22}}
        </h5>
        <p class="card-text">{{product.description | slice:0:48}}</p>
      </a>

      <div class="d-flex flex-price">
        <div>
          <p class="price" *ngIf="validatePrice(product)">
            {{ getPrice(product) | currency:productsService?.currency:'symbol' }}</p>
        </div>
        <div class="ml-auto"><button mat-icon-button color="primary" class="icon-cart" (click)="addToCart(product)">
            <mat-icon>add_shopping_cart</mat-icon>
          </button></div>
      </div>
    </div>
  </div>
</div>
